import styled from 'styled-components';
import { Typ20 } from 'dc/Typ';
import { Ico20 } from 'dc/Ico';

export const UpdateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const UpdateText = styled(Typ20)``;

export const UpdateButton = styled(Ico20)`
  margin-left: 8px;
  cursor: pointer;
`;
